var eventGallery = function(elementID){
    this.elementID = elementID;
    this.element = document.getElementById(elementID);
    if(!this.element) return;

    this.events();
}

eventGallery.prototype.events = function(){
    this.images = this.element.querySelectorAll("img");
    var additionalImages = document.querySelectorAll("*[data-galleryPopup]");
    if(additionalImages){
        this.images = [...this.images,...additionalImages];
    }
    
    this.images.forEach(i=>{
        i.addEventListener("click",(e)=>{
            e.preventDefault();
            this.expand(e.currentTarget);

        });
    });
};

eventGallery.prototype.createPopup = async function(){
    if(this.popup) return;
    this.popup = document.createElement("div");
    this.popup.classList.add("eventGalleryPopup");
    this.popupImage = document.createElement("img");
    this.popup.append(this.popupImage);

    var popupClose = document.createElement("div");
    popupClose.innerHTML = "&times;";
    popupClose.classList.add("close");

    this.popup.append(popupClose);

    popupClose.addEventListener("click",(e)=>{
        e.preventDefault();
        this.popup.classList.remove("show");
    });

    this.popup.addEventListener("click",(e)=>{
        
        if(e.target !== e.currentTarget) return;
        e.preventDefault();
        this.popup.classList.remove("show");
    })

    document.body.appendChild(this.popup);

    var result = await new Promise((resolve,reject)=>{
        setTimeout(()=>{
            resolve(true);
        },100)
    });
    return result;


};

eventGallery.prototype.expand = async function(image){
    var imageSRC = image.getAttribute("src");

    await this.createPopup();
    this.popup.classList.add("show");
    this.popupImage.setAttribute("src",imageSRC);
    
    
    
};